import { useState } from "react";

import { useTranslation, Trans } from "react-i18next";

import r1 from '../../img/Bonus/r1.png'
import r2 from '../../img/Bonus/r2.png'

function ExceptionalBonuses() {

  const { t } = useTranslation();

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
      <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
       <div className="xl:h-[334px] bg-[#2A2A3D] border border-[#47475E] flex justify-between">
        <div className="p-[20px] xl:p-[40px] xl:border-r border-[#47475E]">
            <p className="zen-dots text-[24px] xl:text-[36px] leading-[1.2] text-white"><Trans>{t('edu.1')}</Trans></p>
            <p className="mt-[36px] max-w-[507px] text-[12px] xl:text-[14px] ibm-plex text-[#FFFFFFB2]">{t('edu.2')}</p>
        </div>  
        <img src={r1} alt="" className="mr-[100px] hidden xl:block"/>
       </div>
       <div className="bg-[#2A2A3D] border border-[#47475E] mt-[-1px] p-[20px] xl:h-[492px] xl:p-[40px] xl:pt-[60px] flex justify-between flex-col xl:flex-row gap-[20px]">
        <div className="flex flex-col gap-[20px] xl:gap-[40px]">
            <p className="text-[#FFF] text-[24px] xl:text-[36px] leading-[1.2] zen-dots"><Trans>{t('edu.3')}</Trans></p>
            <div className="flex gap-[8px]">
                <div className="w-[2px] h-[18px] bg-[#FFF] mt-[6px]"></div>
                <div className="">
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF]">{t('edu.4')}</p>
                    <p className="text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex xl:max-w-[487px] mt-[12px]">{t('edu.5')}</p>
                </div>
            </div>
            <div className="flex gap-[8px]">
                <div className="w-[2px] h-[18px] bg-[#FFF] mt-[6px]"></div>
                <div className="">
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF]">{t('edu.6')}</p>
                    <p className="text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex xl:max-w-[487px] mt-[12px]">{t('edu.7')}</p>
                </div>
            </div>
        </div>
        <div className="flex flex-col gap-[20px] xl:gap-[40px]">
            <div className="flex gap-[8px]">
                <div className="w-[2px] h-[18px] bg-[#FFF] mt-[6px]"></div>
                <div className="">
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF]">{t('edu.8')}</p>
                    <p className="text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex xl:max-w-[487px] mt-[12px]">{t('edu.9')}</p>
                </div>
            </div> 
            <div className="flex gap-[8px]">
                <div className="w-[2px] h-[18px] bg-[#FFF] mt-[6px]"></div>
                <div className="">
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF]">{t('edu.10')}</p>
                    <p className="text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex xl:max-w-[487px] mt-[12px]">{t('edu.11')}</p>
                </div>
            </div>          
            <div className="flex gap-[8px]">
                <div className="w-[2px] h-[18px] bg-[#FFF] mt-[6px]"></div>
                <div className="">
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF]">{t('edu.12')}</p>
                    <p className="text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex xl:max-w-[487px] mt-[12px]">{t('edu.13')}</p>
                </div>
            </div>
        </div>
       </div>
       <div className="xl:h-[334px] bg-[#2045FE] flex border border-[#516EFF]">
            <img src={r2} alt="" className="hidden xl:block" />
            <div className=" p-[20px] xl:pt-[50px] xl:border-l border-[#516EFF]">
                <p className="text-[#FFF] text-[24px] xl:text-[36px] leading-[1.2] zen-dots"><Trans>{t('edu.14')}</Trans></p>
                <div className="flex mt-[20px] items-center gap-[16px]">
                    <div className="flex-shrink-0 w-[4px] h-[4px] bg-[#FFF]"></div>
                    <p className="ibm-plex text-[12px] xl:text-[14px] text-[#FFFFFFB2]">{t('edu.15')}</p>
                </div>
                <div className="flex mt-[12px] items-center gap-[16px]">
                    <div className="flex-shrink-0 w-[4px] h-[4px] bg-[#FFF]"></div>
                    <p className="ibm-plex text-[12px] xl:text-[14px] text-[#FFFFFFB2]">{t('edu.16')}</p>
                </div>
                <div className="flex mt-[12px] items-center gap-[16px]">
                    <div className="flex-shrink-0 w-[4px] h-[4px] bg-[#FFF]"></div>
                    <p className="ibm-plex text-[12px] xl:text-[14px] text-[#FFFFFFB2]">{t('edu.17')}</p>
                </div>
                <div className="flex mt-[12px] items-center gap-[16px]">
                    <div className="flex-shrink-0 w-[4px] h-[4px] bg-[#FFF]"></div>
                    <p className="ibm-plex text-[12px] xl:text-[14px] text-[#FFFFFFB2]">{t('edu.18')}</p>
                </div>
            </div>
       </div>
      </div>
    </div>
  );
}

export default ExceptionalBonuses;
